/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_Stage_NameInputs */

const cs_field_stage_name = /** @type {(inputs: Field_Stage_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Název fáze`)
};

const en_field_stage_name = /** @type {(inputs: Field_Stage_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stage name`)
};

/**
* | output |
* | --- |
* | "Stage name" |
*
* @param {Field_Stage_NameInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const field_stage_name = /** @type {((inputs?: Field_Stage_NameInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_Stage_NameInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_stage_name(inputs)
	return cs_field_stage_name(inputs)
});